export default "__VITE_ASSET__DowfszRf__"